<template>
    <div class="relative">
        <div class="p-4 flex-2 z-50">
            <div>
                <h1 class="text-3xl text-orange-600">
                    {{ $t("home.aboutUs").toUpperCase() }}
                </h1>
            </div>
            <div class="flex flex-col lg:flex-row items-center gap-6">
                <!-- Лева страна: слика -->
                <div class="w-full lg:w-1/2 flex justify-center">
                    <img
                        src="/images/about_us.png"
                        alt="О нама"
                        class="max-w-xs lg:max-w-md w-full rounded-xl shadow"
                    />
                </div>

                <!-- Десна страна: текст -->
                <div class="w-full lg:w-1/2 mt-4 lg:mt-0">
                    <div
                        class="flex-2"
                        v-html="`<p>${$t('aboutUs.introduction')}</p>`"
                    ></div>
                </div>
            </div>

            <div class="flex items-center justify-center gap-3 p-6">
                <div class="animate-pulse text-3xl sm:text-4xl">❤️</div>
                <h1
                    class="text-orange-600 font-bold text-2xl sm:text-3xl animate-glow"
                >
                    Healthy<span class="text-orange-500">&</span>Happy
                </h1>
            </div>
            <div
                class="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4"
            >
                <!-- First Column -->
                <div class="flex flex-col gap-4">
                    <!-- Card 1 -->

                    <div class="rounded-lg flex-1">
                        <h1 class="text-2xl font-semibold">
                            {{ $t("aboutUs.servicesTitle") }}
                        </h1>
                        <h1 class="text-xl font-semibold mt-4">
                            {{ $t("aboutUs.videoConsultations") }}
                        </h1>
                        <div v-html="`<p>${$t('aboutUs.services')}</p>`"></div>
                        <h1 class="text-xl font-semibold mt-4">
                            {{ $t("aboutUs.inPersonConsultationsTitle") }}
                        </h1>
                        <div
                            v-html="
                                `<p>${$t('aboutUs.inPersonConsultations')}</p>`
                            "
                        ></div>
                        <h1 class="text-xl font-semibold mt-4">
                            {{ $t("aboutUs.selfServicesTitle") }}
                        </h1>
                        <div
                            class="mt-4"
                            v-html="`<p>${$t('aboutUs.selfServices')}</p>`"
                        ></div>
                    </div>
                </div>

                <!-- Second Column -->
                <div class="flex flex-col gap-4">
                    <!-- Card 3 -->
                    <div class="rounded-lg flex-1">
                        <h1 class="text-2xl font-semibold">
                            {{ $t("aboutUs.missionTitle") }}
                        </h1>
                        <div v-html="`<p>${$t('aboutUs.mission')}</p>`"></div>
                    </div>

                    <!-- Card 4 -->
                    <div class="rounded-lg flex-1">
                        <h1 class="text-2xl font-semibold">
                            {{ $t("aboutUs.visionTitle") }}
                        </h1>
                        <div v-html="`<p>${$t('aboutUs.vision')}</p>`"></div>
                    </div>
                    <div class="rounded-lg flex-1"></div>
                    <div class="rounded-lg flex-1"></div>
                    <div class="rounded-lg flex-1"></div>
                    <div class="rounded-lg flex-1"></div>
                    <div class="rounded-lg flex-1"></div>
                    <div class="rounded-lg flex-1"></div>
                    <div class="rounded-lg flex-1"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
useHead({
    title: "About Us - Cardioteam",
    meta: [
        {
            name: "description",
            content:
                "Learn more about Cardioteam, our mission, and our expert team providing top-notch online healthcare services.",
        },
        { property: "og:title", content: "About Us - Cardioteam" },
        {
            property: "og:description",
            content:
                "Learn more about Cardioteam and our expert online healthcare services.",
        },
    ],
});
</script>

<style scoped>
a {
    color: #ff7e56 !important;
}
</style>
